import { DefaultDeadline, SelectData } from "../../models";
import { OrganisationTypeConstants } from "../organisation";
import { ProjectPhase } from "../project-phase";

export class TemplateTaskConstants {
  // Keyed by the stored default_deadline_field - a camelCase key inside the step phase's object in
  // the target's dates JSON - optionally suffixed with "|<phase>", also camelCase, when the operator
  // depends on which phase the key sits in. Callers must normalise the phase before the lookup; see
  // useTemplateTaskPanelRight.
  //
  // A phase's own boundaries need no phase suffix: a deadline anchored to a phase start always runs
  // forwards and one anchored to a phase end always runs backwards, whichever phase it is.
  public static readonly DEADLINE_OPERATOR_MAP: Record<string, string> = {
    start: "+",
    overallStart: "+",
    end: "-",
    overallEnd: "-",
    "startDate|design": "-",
    "implementationDate|design": "-",
    "registrationDate|feasibility": "-",
  };

  public static readonly PHASE_KEY_DATES_SELECT_DATA_MAP = {
    [ProjectPhase.feasibility]: [
      { key: "creationDate", value: "Creation date" },
      { key: "registrationDate", value: "Registration date" },
      { key: "start", value: "Feasibility start date" },
      { key: "end", value: "Feasibility end date" },
    ] as SelectData,
    [ProjectPhase.design]: [
      { key: "registrationDate", value: "Registration date" },
      { key: "startDate", value: "Project start date" },
      { key: "implementationDate", value: "Project implementation date" },
      { key: "start", value: "Design start date" },
      { key: "end", value: "Design end date" },
    ] as SelectData,
    [ProjectPhase.implementation]: [
      { key: "startDate", value: "Project start date" },
      { key: "implementationDate", value: "Project implementation date" },
      { key: "validationDate", value: "Validation date" },
      { key: "start", value: "Implementation start date" },
      { key: "end", value: "Implementation end date" },
    ] as SelectData,
    [ProjectPhase.ongoingMonitoring]: [
      { key: "validationDate", value: "Validation date" },
      { key: "overallStart", value: "Ongoing monitoring start date" },
      { key: "overallEnd", value: "Ongoing monitoring end date" },
    ] as SelectData,
  };

  public static readonly DEADLINE_OPERATOR_SELECT_DATA = [
    { key: "+", value: "+" },
    { key: "-", value: "-" },
  ] as SelectData;

  public static readonly DEADLINE_CALENDAR_UNIT_SELECT_DATA = [
    { key: "days", value: "days" },
    { key: "weeks", value: "weeks" },
    { key: "months", value: "months" },
    { key: "years", value: "years" },
  ] as SelectData;

  public static readonly ORGANISATION_TYPE_SELECT_DATA_KEYS = {
    [OrganisationTypeConstants.DEVELOPER]: "Developer",
    [OrganisationTypeConstants.DEVELOPMENT_MANAGER]: "Development Manager",
    [OrganisationTypeConstants.ASSET_MANAGER]: "Asset Manager",
    [OrganisationTypeConstants.GUEST]: "Guest",
  };

  public static readonly ORGANISATION_TYPE_SELECT_DATA = [
    {
      key: TemplateTaskConstants.ORGANISATION_TYPE_SELECT_DATA_KEYS[OrganisationTypeConstants.DEVELOPER],
      value: "Developer",
    },
    {
      key: TemplateTaskConstants.ORGANISATION_TYPE_SELECT_DATA_KEYS[OrganisationTypeConstants.DEVELOPMENT_MANAGER],
      value: "Development Manager",
    },
    {
      key: TemplateTaskConstants.ORGANISATION_TYPE_SELECT_DATA_KEYS[OrganisationTypeConstants.ASSET_MANAGER],
      value: "Asset Manager",
    },
    {
      key: TemplateTaskConstants.ORGANISATION_TYPE_SELECT_DATA_KEYS[OrganisationTypeConstants.GUEST],
      value: "Guest",
    },
  ] as SelectData;

  public static readonly DEADLINE_CALENDAR_UNIT_MULTIPLIERS = {
    days: 1,
    weeks: 7,
    months: 30,
    years: 365,
  };

  public static readonly DEFAULT_TEMPLATE_TASK = {
    defaultDeadlineField: null,
    defaultDeadlineValue: null,
    defaultIsMandatory: null,
    defaultIsMilestone: null,
    defaultKeyDate: null,
    defaultRepeat: null,
    defaultTaskDescription: null,
    defaultTaskName: null,
    defaultVisibility: null,
    ownerOrganisationType: null,
    workflowTemplateStepUuid: null,
  };

  public static readonly DEFAULT_DEADLINE = {
    operator: "+",
    value: 0,
    unit: "days",
  } as DefaultDeadline;
}
